<template>
  <v-row>
    <v-col sm="1" lg="2" class="hidden-xs-only">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" sm="10" lg="8">
      <DetailCard title="Detalles Participante" :loading="cardLoading">
        <v-row justify="center">
          <v-col
            v-for="(item, index) in participante"
            :key="index"
            cols="12"
            sm="10"
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != null">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">No registrado</p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>
<script>
import DetailCard from "../../../components/admin/DetailCard.vue";
export default {
  data: () => ({
    cardLoading: true,
  }),
  mounted() {
    this.$store.dispatch(
      "gestionarGanadorWorldSkills",
      this.$route.params.id_competencia,
    );
    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },
  components: {
    DetailCard,
  },

  computed: {
    participante() {
      const ganador = this.$store.getters.obtenerGanadorWorldSkills(
        this.$route.params.id_evaluacion,
      );
      const ganadores = [
        {
          label: "Identificación",
          value: ganador.identificacion,
        },
        {
          label: "Nombres",
          value: ganador.nombres,
        },
        {
          label: "Apellidos",
          value: ganador.apellidos,
        },
        {
          label: "Télefono",
          value: ganador.telefono,
        },
        {
          label: "Correo Electrónico",
          value: ganador.correo,
        },
        {
          label: "Fecha de Nacimiento",
          value: ganador.fecha_nacimiento,
        },
        {
          label: "Género",
          value: ganador.genero,
        },
        {
          label: "Programa de Formación",
          value: ganador.programa_formacion,
        },
        {
          label: "Número de Ficha",
          value: ganador.numero_ficha,
        },
        {
          label: "Medalla",
          value: ganador.medalla,
        },
        {
          label: "Puntaje",
          value: ganador.puntaje ?? "No registrado",
        },
        {
          label: "Descripción",
          value: ganador.descripcion ?? "No registrado",
        },
        {
          label: "Regional",
          value: ganador.regional,
        },
        {
          label: "Centro de Formación",
          value: ganador.centro_formacion,
        },
        {
          label: "Habilidad",
          value: ganador.categoria,
        },
        {
          label: "Competencia",
          value: ganador.competencia,
        },
      ];
      return ganadores;
    },
  },

  methods: {
    regresar() {
      this.$router.go(-1)
    }
  },
};
</script>
